// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".change-password-container.form-container button {\n  margin-top: 30px;\n}\n\n.change-password-alert {\n  width: 100%;\n  height: 60px;\n  display: flex;\n  align-items: center;\n  margin: 40px 0 0;\n  border-radius: 5px;\n}\n\n.change-password-alert.success {\n  background-color: var(--green);\n}\n\n.change-password-alert.failure {\n  background-color: var(--red);\n}\n\n.account-settings-container .card .change-password-alert p {\n  margin: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
